import { render, staticRenderFns } from "./ManualRequest.vue?vue&type=template&id=52201c69&"
import script from "./ManualRequest.vue?vue&type=script&lang=js&"
export * from "./ManualRequest.vue?vue&type=script&lang=js&"
import style0 from "./ManualRequest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports